import {
  getBookingsSettings as publicGetBookingsSettings,
  updateBookingsSettings as publicUpdateBookingsSettings,
} from './bookings-v2-bookings-settings-bookings-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onBookingsSettingsCreated as publicOnBookingsSettingsCreated } from './bookings-v2-bookings-settings-bookings-settings.public.js';
import { onBookingsSettingsDeleted as publicOnBookingsSettingsDeleted } from './bookings-v2-bookings-settings-bookings-settings.public.js';
import { onBookingsSettingsUpdated as publicOnBookingsSettingsUpdated } from './bookings-v2-bookings-settings-bookings-settings.public.js';

export const getBookingsSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetBookingsSettings> &
    typeof publicGetBookingsSettings
> = /*#__PURE__*/ createRESTModule(publicGetBookingsSettings);
export const updateBookingsSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateBookingsSettings> &
    typeof publicUpdateBookingsSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateBookingsSettings);
/**
 * (explanation)
 *
 * Events are an integral part of your API and should be designed alongside all other methods that your domain exposes.
 * Remember - events are the only way a client can react to your domain's business flow without constantly polling your
 * API for changes.
 *
 * Therefore you MUST expose all lifecycle events even if you don't have a use case in your own business flows that
 * consumes them.
 *
 * In order to simplify clients ability to consume events in a coherent way, we have defined a common standard for
 * sending events from platformized services related to your domain (hence DomainEvents). This is both inside Wix and
 * externally (webhooks and velo).
 *
 * Refer to [AIP 7016 - Events and Hooks][1] to learn more about callback annotation.
 * Callback is an event, which is fired as a byproduct of calling this method.
 *
 * [1]: https://dev.wix.com/docs/rnd-general/articles/p13n-guidelines-aips/guidance-aips/design-patterns/7016-events
 */
export const onBookingsSettingsCreated: BuildEventDefinition<
  typeof publicOnBookingsSettingsCreated
> &
  typeof publicOnBookingsSettingsCreated = createEventModule(
  publicOnBookingsSettingsCreated
);
/** */
export const onBookingsSettingsDeleted: BuildEventDefinition<
  typeof publicOnBookingsSettingsDeleted
> &
  typeof publicOnBookingsSettingsDeleted = createEventModule(
  publicOnBookingsSettingsDeleted
);
/** */
export const onBookingsSettingsUpdated: BuildEventDefinition<
  typeof publicOnBookingsSettingsUpdated
> &
  typeof publicOnBookingsSettingsUpdated = createEventModule(
  publicOnBookingsSettingsUpdated
);

export {
  BasedOn,
  PlacementType,
  StaffSelectionTiming,
  Strategy,
  Timing,
  WebhookIdentityType,
  RequiredField,
  RequestedFields,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  Reason,
} from './bookings-v2-bookings-settings-bookings-settings.universal.js';
export {
  BookingsSettings,
  CartCheckout,
  MultiServiceAppointments,
  DisplayTimeZone,
  SiteProperties,
  Locale,
  Address,
  AddressHint,
  GeoCoordinates,
  Features,
  Feature,
  ExtendedFields,
  Notifications,
  StaffSelection,
  LocationSelection,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  OwnerFlow,
  BookingCreationSettings,
  GetBookingsSettingsRequest,
  GetBookingsSettingsResponse,
  UpdateBookingsSettingsRequest,
  UpdateBookingsSettingsResponse,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  BusinessNotification,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  BookingsSettingsCreatedEnvelope,
  BookingsSettingsDeletedEnvelope,
  BookingsSettingsUpdatedEnvelope,
} from './bookings-v2-bookings-settings-bookings-settings.universal.js';
export {
  BasedOnWithLiterals,
  PlacementTypeWithLiterals,
  StaffSelectionTimingWithLiterals,
  StrategyWithLiterals,
  TimingWithLiterals,
  WebhookIdentityTypeWithLiterals,
  RequiredFieldWithLiterals,
  RequestedFieldsWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  ReasonWithLiterals,
  GetBookingsSettingsApplicationErrors,
} from './bookings-v2-bookings-settings-bookings-settings.universal.js';
